import script from "./PersonalSettingsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalSettingsForm.vue?vue&type=script&setup=true&lang=js"

import "./PersonalSettingsForm.vue?vue&type=style&index=0&id=c61643d0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c61643d0"]])

export default __exports__